module.exports = __webpack_public_path__ + "media/images/athletes/3582-4a35c14f5645a6aa57fadb6d13e6e674.png";